import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Hotel Abroad Service
 * Yurtdışı otel sayfaları için gerekli API isteklerini yönetir.
 */
export const hotelAbroadService = {
  /**
   * Popüler otel lokasyonlarını getirir
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu (örn: "tr", "en")
   * @param {string} [payload.CurrencyCode] - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getPopularHotelLocationsTitle: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.abroad.getPopularHotelLocationsTitle,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler uluslararası otelleri getirir (popularhotels endpoint)
   * @param {Object} payload - API payload
   * @param {boolean} [payload.IsInternational] - true
   * @param {string} [payload.LanguageCode] - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<{ PopularHotels: Array }>} API response
   *
   * Payload Example:
   * {
   *   "IsInternational": true,
   *   "LanguageCode": "tr"
   * }
   */
  getPopularCountryHotels: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.abroad.getPopularCountryHotels,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler otel ülkelerini getirir
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu (örn: "tr", "en")
   * @param {string} [payload.Section] - Section değeri (örn: "PopularEuropeanCountries")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   *
   * Payload Example:
   * {
   *   "Section": "PopularEuropeanCountries",
   *   "LanguageCode": "tr"
   * }
   */
  getPopularHotelLocations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.abroad.getPopularHotelLocations,
      payload,
      headers,
      hasErrorHandler,
    }),
};

export default hotelAbroadService;
